import { URLS } from "@/api/urls";
import { User } from "@/types/User";

import fetcher_v2, { ErrorMessages } from "../fetcher_v2";

export type SignupBody = Pick<User, "email" | "name"> & {
  password: string;
  name: string;
  organization_name: string;
  language: string;
  turnstileToken: string;
  company_name?: string;
  full_company_name?: string;
  company_description?: string;
};

export type SignupParams = {
  validate?: boolean;
} & SignupBody;

export const signup = (body: SignupParams) => {
  return fetcher_v2<SignupBody, SignupParams, ErrorMessages<SignupBody>>(
    URLS.SIGNUP,
    {
      method: "POST",
      body,
    }
  );
};
